export const heapSortCode = {
    c: `
  void heapify(int arr[], int n, int i) {
      int largest = i;
      int left = 2 * i + 1;
      int right = 2 * i + 2;
      if (left < n && arr[left] > arr[largest])
          largest = left;
      if (right < n && arr[right] > arr[largest])
          largest = right;
      if (largest != i) {
          int temp = arr[i];
          arr[i] = arr[largest];
          arr[largest] = temp;
          heapify(arr, n, largest);
      }
  }
  
  void heapSort(int arr[], int n) {
      for (int i = n / 2 - 1; i >= 0; i--)
          heapify(arr, n, i);
      for (int i = n - 1; i > 0; i--) {
          int temp = arr[0];
          arr[0] = arr[i];
          arr[i] = temp;
          heapify(arr, i, 0);
      }
  }`,
    cpp: `
  void heapify(int arr[], int n, int i) {
      int largest = i;
      int left = 2 * i + 1;
      int right = 2 * i + 2;
      if (left < n && arr[left] > arr[largest])
          largest = left;
      if (right < n && arr[right] > arr[largest])
          largest = right;
      if (largest != i) {
          std::swap(arr[i], arr[largest]);
          heapify(arr, n, largest);
      }
  }
  
  void heapSort(int arr[], int n) {
      for (int i = n / 2 - 1; i >= 0; i--)
          heapify(arr, n, i);
      for (int i = n - 1; i > 0; i--) {
          std::swap(arr[0], arr[i]);
          heapify(arr, i, 0);
      }
  }`,
    java: `
  public class HeapSort {
      public static void heapify(int[] arr, int n, int i) {
          int largest = i;
          int left = 2 * i + 1;
          int right = 2 * i + 2;
          if (left < n && arr[left] > arr[largest])
              largest = left;
          if (right < n && arr[right] > arr[largest])
              largest = right;
          if (largest != i) {
              int temp = arr[i];
              arr[i] = arr[largest];
              arr[largest] = temp;
              heapify(arr, n, largest);
          }
      }
  
      public static void heapSort(int[] arr) {
          int n = arr.length;
          for (int i = n / 2 - 1; i >= 0; i--)
              heapify(arr, n, i);
          for (int i = n - 1; i > 0; i--) {
              int temp = arr[0];
              arr[0] = arr[i];
              arr[i] = temp;
              heapify(arr, i, 0);
          }
  }`,
    python: `
  def heapify(arr, n, i):
      largest = i
      left = 2 * i + 1
      right = 2 * i + 2
      if left < n and arr[left] > arr[largest]:
          largest = left
      if right < n and arr[right] > arr[largest]:
          largest = right
      if largest != i:
          arr[i], arr[largest] = arr[largest], arr[i]
          heapify(arr, n, largest)
  
  def heapSort(arr):
      n = len(arr)
      for i in range(n // 2 - 1, -1, -1):
          heapify(arr, n, i)
      for i in range(n - 1, 0, -1):
          arr[0], arr[i] = arr[i], arr[0]
          heapify(arr, i, 0)
  `
  };
  